export default "__VITE_ASSET__Cp_2VhHN__";